import { useQuery, QueryClient } from "@tanstack/react-query";
import { referenceDataMapping } from "../../mapping/referenceDataMapping.js";
import { queryKeys } from "./queryKeys.js";
import useSharedData from "../useSharedData.ts";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";
import { isObjEmpty } from "../../utilities/utils.js";

//----------------------------------------------------------------

const queryClient = new QueryClient();

const fetchReferenceData = async (openErrorModal, pdsUrl, setPdsUrl) => {
	const cachedRefData = queryClient.getQueryData([
		queryKeys.REFERENCE_DATA_FETCH,
	]);

	if (!isObjEmpty(cachedRefData)) {
		return cachedRefData;
	}

	const response = await request({
		url: "/getReferenceData",
		method: "GET",
	});
	if (200 !== response.status) {
		openErrorModal();
		throw response;
	} else {
		if (!pdsUrl) {
			// Only set if it wasn't set before
			await setPdsUrl(response?.data?.pdsUrl);
		}
		let returnResponse = await referenceDataMapping(response.data);
		return returnResponse;
	}
};

export const useGetReferenceData = () => {
	const { openErrorModal, pdsUrl, setPdsUrl } = useSharedData();

	return useQuery({
		queryKey: [queryKeys.REFERENCE_DATA_FETCH],
		queryFn: async () =>
			await fetchReferenceData(openErrorModal, pdsUrl, setPdsUrl),
		refetchOnWindowFocus: false,
		cacheTime: 15 * (60 * 1000),
		staleTime: Infinity,
	});
};
